<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 mt-4 mb-5">
                <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                        <div class="counceltitle__flex">
                            <div>
                                <h5 class="councel__name">Asset QR Approval</h5>
                            </div>
                        </div>
                        <table class="table_campus">
                            <tbody>
                                <tr>
                                    <td class="campus_list">
                                        Campus
                                    </td>
                                    <td class="campus_text">
                                        <select name="" id="" style="width: 285px;" class="drpdwn"
                                            (change)="onSelectedCampus($event)">
                                            <option value="">Select Campus</option>
                                            <option *ngFor="let data of campusdetails" [value]="data.campusId">
                                                {{data?.campusName}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="campus_list">
                           
                        </div> -->
                        <div class="ibox-content">
                            <mat-card>
                                <ng-container *ngIf="dataAvailable; else noData">
                                    <!--- no data-->
                                    <div class="searchpaginator">
                                        <div class="table_search">
                                            <input type="text" class="form-control" (keyup)="applyFilter($event)"
                                                placeholder="Search">
                                        </div>
                                        <div>
                                            <mat-paginator [pageSize]="10"
                                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                        </div>
                                        <!-- <span (click)="exportAsXLSX()"><img src="../../assets/image/vscode-icons_file-type-excel.svg" class="excel_sheet" alt=""></span> -->
                                    </div>
                                    <div class="table-responsive">
                                        <mat-card-content>
                                            <table mat-table [dataSource]="approvalQRData" class="table_resize">
                                                <ng-container matColumnDef="fusioncode">
                                                    <th mat-header-cell *matHeaderCellDef class="resizer">Bld Fusion
                                                        Code
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.orcFusionBuildingCode}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="buildingName">
                                                    <th mat-header-cell *matHeaderCellDef>Oracle Building Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.buildingName}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="minorcategoryname">
                                                    <th mat-header-cell *matHeaderCellDef> Minor Category Name </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.minorCategoryName}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="blockno">
                                                    <th mat-header-cell *matHeaderCellDef>Block No</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.blockNo}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="blockname">
                                                    <th mat-header-cell *matHeaderCellDef>Block Name</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.blockName}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="floorno">
                                                    <th mat-header-cell *matHeaderCellDef>Floor No</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.floorNo}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="roomtype">
                                                    <th mat-header-cell *matHeaderCellDef>Room Type</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.roomType}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="roomno">
                                                    <th mat-header-cell *matHeaderCellDef>Room No</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.roomNo}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="noofassests">
                                                    <th mat-header-cell *matHeaderCellDef> No of Assets</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        {{row.totalAssets}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="status">
                                                    <th mat-header-cell *matHeaderCellDef> Status
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'pending_row':row.approveStatus === 'PENDING'}">
                                                        <ng-container *ngIf="row.approveStatus === 'PENDING'">
                                                            <p (click)="pending(row)" class="pending_list">PENDING</p>
                                                        </ng-container>
                                                        <ng-container *ngIf="row.approveStatus !== 'PENDING'">
                                                            <p>APPROVED</p>
                                                        </ng-container>
                                                    </td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="displayedColumns  sticky: true">
                                                </tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                                <tr class="mat-row" *matNoDataRow>
                                                    <td class="mat-cell" class="not_matchdata" colspan="10">No data
                                                        matching the filter
                                                    </td>
                                                </tr>
                                            </table>
                                        </mat-card-content>
                                    </div>
                                </ng-container>

                            </mat-card>
                            <ng-template #noData>
                                <section class="section_one">
                                    <div class="cctvcouncelling__sec">
                                        <div class="councellist__flex">
                                            <div>
                                                <div class="nodata_center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../assets/image/nodata.png" alt="nodata"
                                                            class="nodata">
                                                    </figure>
                                                    <p class="no_data">No Data Found</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>